<template>
    <div class="message_design text-center">
        <span> Retrieving User Details please wait... </span>
    </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
    name: "AuthUser",
    methods: {
        ...mapActions(["getAccessToken"]),

        redirectToPage() {
            if (
                this.$store.state.user == null ||
                this.$store.state.user == [] ||  
                JSON.parse(this.$store.state.user).organizationRequest ==
                    null ||
                JSON.parse(this.$store.state.user).organizationRequest
                    .organizationProgressList == null
            ) {
                this.redirectToMainPage();
            } else {
                let orgProgressList = JSON.parse(this.$store.state.user)
                    .organizationRequest.organizationProgressList;
                if (orgProgressList.length > 0) {
                    this.status =
                        orgProgressList[
                            orgProgressList.length - 1
                        ].progressType;
                }
                switch (this.status) {
                    case "OFAC_VERIFIED":
                        this.$router.push({ path: "/thankyou" });
                        break;
                    case "DOCUSIGN_INITIATED":
                        this.$router.push({ path: "/thankyou" });
                        break;
                    case "DOCUSIGN_LEVEL1_SIGNED":
                        this.$router.push({ path: "/welcomereview" });
                        break;
                    case "DOCUSIGN_COMPLETED":
                        this.redirectToMainPage();
                        break;
                    default:
                        this.redirectToMainPage();
                }
            }
        },

        redirectToMainPage() {
            if (this.$store.state.Auth) {
                if (
                    JSON.parse(this.$store.state.Auth.user).memberType === "SUS" ||
                    JSON.parse(this.$store.state.Auth.user).memberType === "STD"
                ) {
                    window.open(
                        "https://financialdataexchange.org/" + "FDX/FDX/MemberHome.aspx",
                        "_self"
                    );

                } else {
                    window.open(
                        "https://financialdataexchange.org/" + "FDX/FDX/FDX_API.aspx",
                        "_self"
                    );
                }
            }
            if (JSON.parse(this.$store.state.user).membershipType) {
                if (JSON.parse(this.$store.state.user).membershipType === "FDX_MEMBER") {
                    window.open(
                        "https://financialdataexchange.org/" + "FDX/FDX/MemberHome.aspx",
                        "_self"
                    );
                } else {
                    window.open(
                        "https://financialdataexchange.org/" + "FDX/FDX/FDX_API.aspx",
                        "_self"
                    );
                }
            }
        },
    },
    data() {
        return {
            status: "LOADING",
        };
    },
    created() {
        if (this.$route.query && this.$route.query.idToken && this.$route.query.refreshToken && this.$route.query.accessToken) {
            const params = new URLSearchParams(window.location.search);
            if (params) {
                const tokenDetails = {
                    idToken: params.get('idToken'),
                    refreshToken: params.get('refreshToken'),
                    accessToken: params.get('accessToken'),
                    expiresIn: params.get('expiresIn'),
                    scope: 'openid profile',
                    userName: null
                };
                if (tokenDetails) {
                    this.getAccessToken(tokenDetails);
                }
            }
        }
        this.unsubscribe = this.$store.subscribe((mutation) => {
            if (mutation.type === "setUser" && mutation.payload !== null) {
                this.redirectToPage();
            }
        });
    },
};
</script>
<style scoped>
.message_design {
    background-color: #0f8575;
    color: white;
    padding: 10px;
    margin: 10px 0;
}
</style>